"use strict";

/**
 * Main Application Script - Clean Modular Version
 * Coordinates all modules and initializes the application
 * 
 * Phase 11: Final Cleanup - All logic moved to modules
 */

// Import main initialization module that handles everything
import { MainApp } from './modules/main-init.js';

// Global variables (kept minimal)
var cachedRequest = { 'request': '  ', 'filterUpdate': true, 'mCondPrev': [] };
var searchMode = "fulltext", searchProgressLatestInFiles = 33, QUERY = "";
var filesList = [], trees = {}, search_categories = [];
var isPublicMode = false, userAuthenticated = false;
var INITIALIZED = false, INITIALIZED2 = false;

// Essential constants
const SEARCH_LIMIT = 200;
const CLOUD_URL = window.CLOUD_URL || '';

// Check if debug mode is enabled (global)
const debugMode = window.debugMode || '0';

// Debug function (compatibility)
window.l = function(msg) {
    if (debugMode === '1') {
        console.log(msg);
    }
};

// HyperLog compatibility setup
if (window.HyperLog) {
    
    if (!HyperLog.warn) {
        HyperLog.warn = HyperLog.info || console.warn;
    }
    if (!HyperLog.error) {
        HyperLog.error = HyperLog.info || console.error;
    }
} else {
    window.HyperLog = {
        info: console.log,
        warn: console.warn,
        error: console.error,
        debug: console.log
    };
}

// Main application instance
let mainApp = null;

// ⚡ НЕМЕДЛЕННЫЙ ЭКСПОРТ ФУНКЦИЙ - до async инициализации!
window.getMainApp = () => mainApp;
window.getMainAppStatus = () => ({
    initialized: INITIALIZED,
    version: 'clean_modular',
    mainApp: mainApp ? 'initialized' : 'not_initialized'
});

/**
 * Initialize application when DOM is ready
 */
function initializeMainApp() {
    
    // Check if jQuery is available
    if (typeof $ === 'undefined') {
        console.warn('[main.js] ⏳ jQuery not loaded yet, retrying in 100ms...');
        if (debugMode === '1') {
            console.error("❌ jQuery not loaded yet, retrying in 100ms...");
        }
        setTimeout(initializeMainApp, 100);
        return;
    }
    
    // Check if MainApp is available
    if (typeof MainApp === 'undefined') {
        console.warn('[main.js] ⏳ MainApp not loaded yet, retrying in 100ms...');
        if (debugMode === '1') {
            console.error("❌ MainApp not loaded yet, retrying in 100ms...");
        }
        setTimeout(initializeMainApp, 100);
        return;
    }
    
    $(document).ready(async function () {
        try {
            // Create and initialize main application
            mainApp = new MainApp();
            await mainApp.init();
            
            // Mark as initialized
            INITIALIZED = true;
            INITIALIZED2 = true;
            
            
            // Global exports for debugging and compatibility
            window.mainApp = mainApp; // Set global instance
            // Functions already exported above - just update references
            
            // Trigger custom event when ready
            window.dispatchEvent(new CustomEvent('mainAppReady', { 
                detail: { mainApp, initialized: INITIALIZED } 
            }));
            
        } catch (error) {
            console.error('[main.js] ❌ MainApp initialization failed:', error);
            console.error('[main.js] ❌ Error stack:', error.stack);
            if (debugMode === '1') {
                console.error("❌ Main.js initialization failed:", error);
            }
            window.dispatchEvent(new CustomEvent('mainAppError', { detail: error }));
        }
    });
}

// Start initialization with dependency checks

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        initializeMainApp();
    });
} else {
    // DOM already ready
    initializeMainApp();
}
